export class SearchSuggest {
  titulo: string;
  termo: string;
  url: string;
  qtd: number;
}
